const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

export const ConfigForm = ({ config, setConfig, isConnected, successMessage, countdown }) => {
  // Not connected - show only the command to run
  if (!isConnected) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px'
      }}>
        <div style={{
          fontSize: '16px',
          color: '#111827',
          marginBottom: '12px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          width: '100%',
          maxWidth: '400px',
          textAlign: 'left'
        }}>
          Configure Bonzai settings with:
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          maxWidth: '400px',
          padding: '16px 20px',
          background: '#f5f5f5',
          borderRadius: '12px',
          border: '1px solid #e5e5e5'
        }}>
          <code style={{
            fontSize: '15px',
            color: '#333',
            fontFamily: 'monospace',
            fontWeight: '500'
          }}>
            npx bonzai-tree
          </code>
          <button
            onClick={() => copyToClipboard('npx bonzai-tree')}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: 0.5,
              transition: 'opacity 0.15s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '0.5'}
            title="Copy to clipboard"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#666" style={{ width: '20px', height: '20px' }}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
            </svg>
          </button>
        </div>
      </div>
    );
  }

  // Connected - show form fields
  return (
    <>
      {successMessage && (
        <div style={{
          padding: '12px',
          background: '#f0fdf4',
          color: '#16a34a',
          borderRadius: '6px',
          fontSize: '13px',
          marginBottom: '16px',
          fontWeight: '500',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>{successMessage}</span>
          {countdown && (
            <span style={{ opacity: 0.8 }}>
              disconnecting in {countdown}...
            </span>
          )}
        </div>
      )}

      {/* Custom Checks Section */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: '#111827',
          marginBottom: '8px'
        }}>
          Custom Requirements
        </label>
        <textarea
          value={config.customChecks.requirements}
          onChange={(e) => setConfig(prev => ({
            ...prev,
            customChecks: { ...prev.customChecks, requirements: e.target.value }
          }))}
          placeholder="e.g., Remove unused imports and variables. Remove all console log statements."
          style={{
            width: '100%',
            padding: '10px 12px',
            fontSize: '13px',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            background: '#fff',
            color: '#111827',
            outline: 'none',
            resize: 'vertical',
            minHeight: '60px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}
        />
        <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>
          Custom cleanup rules to apply during burns
        </div>
      </div>

      {/* ESLint Section */}
      <label style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 0',
        cursor: 'pointer',
        borderBottom: '1px solid #f3f4f6'
      }}>
        <input
          type="checkbox"
          checked={config.eslint.enabled}
          onChange={(e) => setConfig(prev => ({
            ...prev,
            eslint: { ...prev.eslint, enabled: e.target.checked }
          }))}
          style={{
            width: '18px',
            height: '18px',
            cursor: 'pointer',
            accentColor: '#3B82F6'
          }}
        />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '14px', color: '#111827', fontWeight: '500' }}>ESLint</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Run ESLint checks (no-unused-vars)</div>
        </div>
      </label>

      {/* TypeScript Section */}
      <label style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 0',
        cursor: 'pointer',
        borderBottom: '1px solid #f3f4f6'
      }}>
        <input
          type="checkbox"
          checked={config.typescript.enabled}
          onChange={(e) => setConfig(prev => ({
            ...prev,
            typescript: { ...prev.typescript, enabled: e.target.checked }
          }))}
          style={{
            width: '18px',
            height: '18px',
            cursor: 'pointer',
            accentColor: '#3B82F6'
          }}
        />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '14px', color: '#111827', fontWeight: '500' }}>TypeScript</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Run TypeScript type checking</div>
        </div>
      </label>

      {/* Line Limit Section */}
      <div style={{
        padding: '10px 0',
        borderBottom: '1px solid #f3f4f6'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '8px'
        }}>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer'
          }}>
            <input
              type="checkbox"
              checked={config.lineLimit.enabled}
              onChange={(e) => setConfig(prev => ({
                ...prev,
                lineLimit: { ...prev.lineLimit, enabled: e.target.checked }
              }))}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer',
                accentColor: '#3B82F6'
              }}
            />
            <div style={{ fontSize: '14px', color: '#111827', fontWeight: '500' }}>Line Limit</div>
          </label>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            opacity: config.lineLimit.enabled ? 1 : 0.5
          }}>
            <span style={{ fontSize: '13px', color: '#6b7280' }}>Max</span>
            <input
              type="number"
              value={config.lineLimit.limit}
              onChange={(e) => setConfig(prev => ({
                ...prev,
                lineLimit: { ...prev.lineLimit, limit: parseInt(e.target.value) || 0 }
              }))}
              disabled={!config.lineLimit.enabled}
              style={{
                width: '70px',
                padding: '6px 10px',
                fontSize: '13px',
                border: '1px solid #d1d5db',
                borderRadius: '4px',
                textAlign: 'center',
                background: config.lineLimit.enabled ? '#fff' : '#f9fafb'
              }}
            />
            <span style={{ fontSize: '13px', color: '#6b7280' }}>lines</span>
          </div>
        </div>
      </div>

      {/* Folder Limit Section */}
      <div style={{
        padding: '10px 0',
        borderBottom: '1px solid #f3f4f6'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '8px'
        }}>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer'
          }}>
            <input
              type="checkbox"
              checked={config.folderLimit.enabled}
              onChange={(e) => setConfig(prev => ({
                ...prev,
                folderLimit: { ...prev.folderLimit, enabled: e.target.checked }
              }))}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer',
                accentColor: '#3B82F6'
              }}
            />
            <div style={{ fontSize: '14px', color: '#111827', fontWeight: '500' }}>Folder Limit</div>
          </label>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            opacity: config.folderLimit.enabled ? 1 : 0.5
          }}>
            <span style={{ fontSize: '13px', color: '#6b7280' }}>Max</span>
            <input
              type="number"
              value={config.folderLimit.limit}
              onChange={(e) => setConfig(prev => ({
                ...prev,
                folderLimit: { ...prev.folderLimit, limit: parseInt(e.target.value) || 0 }
              }))}
              disabled={!config.folderLimit.enabled}
              style={{
                width: '70px',
                padding: '6px 10px',
                fontSize: '13px',
                border: '1px solid #d1d5db',
                borderRadius: '4px',
                textAlign: 'center',
                background: config.folderLimit.enabled ? '#fff' : '#f9fafb'
              }}
            />
            <span style={{ fontSize: '13px', color: '#6b7280' }}>items</span>
          </div>
        </div>
      </div>

      {/* Test Check Section */}
      <div style={{
        padding: '10px 0'
      }}>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          cursor: 'pointer'
        }}>
          <input
            type="checkbox"
            checked={config.testCheck.enabled}
            onChange={(e) => setConfig(prev => ({
              ...prev,
              testCheck: { ...prev.testCheck, enabled: e.target.checked }
            }))}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer',
              accentColor: '#3B82F6'
            }}
          />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '14px', color: '#111827', fontWeight: '500' }}>Test Coverage Check</div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>Flag components missing test files</div>
          </div>
        </label>
      </div>
    </>
  );
};
